import React from "react";
import CitationBadge from "@/components/chat/CitationBadge";
import type {CitationSource} from "@/types/ask";

/** Normalize className to an array for includes() checks. */
const toClassNameList = (className: unknown): string[] => {
   if (Array.isArray(className)) return className;
   if (typeof className === "string" && className) return [className];
   return [];
};

const CitationSpan: React.FC<{
   className?: any;
   id?: string;
   children?: React.ReactNode;
   citations?: CitationSource[];
   [key: string]: any;
}> = ({className, id, children, citations, ...props}) => {
   const classNames = toClassNameList(className);
   if (citations && classNames.includes("citation-ref") && typeof id === "string") {
      const rawId = id.replace(/^user-content-/, "");
      if (rawId.startsWith("citation-ref-")) {
         const num = Number.parseInt(rawId.replace("citation-ref-", ""), 10);
         if (!Number.isNaN(num)) {
            return <CitationBadge numbers={[num]} citations={citations} />;
         }
      }
   }
   return <span className={className} id={id} {...props}>{children}</span>;
};

export default CitationSpan;
